const types = ({ apiClient }) => ({
  list(params) {
    return apiClient.get('/types', {}, params)
  },
})

export default types
